import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { LuX } from 'react-icons/lu';

const PANEL_WIDTH = 430;

const PANEL_CSS = `
.su-sp { position: fixed; right: 0; bottom: 0; z-index: 960; width: ${PANEL_WIDTH}px; max-width: calc(100vw - 80px); display: flex; flex-direction: column; border-left: 1px solid var(--su-line); background: var(--su-surface); }
.su-sp-h { display: flex; align-items: center; gap: 10px; min-height: 64px; padding: 8px 14px; border-bottom: 1px solid var(--su-line-2); flex-shrink: 0; }
.su-sp-x { width: 38px; height: 38px; flex-shrink: 0; display: grid; place-items: center; border: none; border-radius: 10px; background: none; color: var(--su-ink); cursor: pointer; }
.su-sp-x:hover { background: var(--su-raised); }
.su-sp-t { flex: 1; min-width: 0; }
.su-sp-t b { display: block; font-size: 19px; font-weight: 600; line-height: 1.2; color: var(--su-ink); }
.su-sp-t small { display: block; font-size: 12.5px; color: var(--su-ink-3); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.su-sp-b { flex: 1; min-height: 0; overflow-y: auto; }
.su-sp-b::-webkit-scrollbar { width: 6px; }
.su-sp-b::-webkit-scrollbar-thumb { border-radius: 6px; background: transparent; }
.su-sp-b:hover::-webkit-scrollbar-thumb { background: var(--su-control); }
`;

const SidePanel = ({ title, subtitle, onClose, children }) => {
  const anchorRef = useRef(null);
  const [shell, setShell] = useState(null);
  const [top, setTop] = useState(0);

  useLayoutEffect(() => {
    const root = anchorRef.current?.closest('.su-canvas-root');
    const wrapper = anchorRef.current?.closest('.reactflow-wrapper');
    setShell(root || null);
    const measure = () => setTop(root ? root.getBoundingClientRect().top : 0);
    measure();
    window.addEventListener('resize', measure);
    if (wrapper) wrapper.style.marginRight = `${PANEL_WIDTH}px`;
    return () => {
      window.removeEventListener('resize', measure);
      if (wrapper) wrapper.style.marginRight = '0px';
    };
  }, []);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <span ref={anchorRef} style={{ display: 'none' }}>
      {shell &&
        createPortal(
          <aside className="su-sp" role="complementary" aria-label={title} style={{ top: `${top}px` }}>
            <style>{PANEL_CSS}</style>
            <div className="su-sp-h">
              <button type="button" className="su-sp-x" aria-label="Cerrar" onClick={onClose}>
                <LuX className="su-ic" size={18} />
              </button>
              <div className="su-sp-t">
                <b>{title}</b>
                {subtitle && <small title={subtitle}>{subtitle}</small>}
              </div>
            </div>
            <div className="su-sp-b">{children}</div>
          </aside>,
          shell
        )}
    </span>
  );
};

export default SidePanel;
